import { render, staticRenderFns } from "./BookingRoomDetailDialog.vue?vue&type=template&id=0972b092"
import script from "./BookingRoomDetailDialog.vue?vue&type=script&lang=js"
export * from "./BookingRoomDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports